import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const SearchOff = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M33.4481 29.6981H35.0962L45.49 40.1144L42.3856 43.2188L31.9712 32.8225V31.1769L31.4087 30.5938C28.9582 32.7063 25.8297 33.8671 22.5943 33.8644C22.2461 33.8643 21.8982 33.8435 21.5525 33.8019V29.5938C21.898 29.6492 22.2465 29.6841 22.5962 29.6981C24.4015 29.7019 26.1693 29.183 27.6863 28.2043C29.2033 27.2255 30.4046 25.8287 31.1453 24.1823C31.8859 22.5359 32.1343 20.7103 31.8604 18.9259C31.5864 17.1415 30.802 15.4745 29.6016 14.126C28.4012 12.7776 26.8362 11.8054 25.0955 11.3267C23.3548 10.848 21.5128 10.8833 19.7917 11.4284C18.0706 11.9734 16.5441 13.0049 15.3962 14.3984C14.2484 15.7918 13.5284 17.4877 13.3231 19.2813H9.11496C9.27806 17.149 9.94423 15.0858 11.0588 13.2608C12.1735 11.4357 13.7048 9.90091 15.5273 8.7821C17.3497 7.6633 19.4114 6.9924 21.5433 6.82441C23.6751 6.65642 25.8165 6.99613 27.7917 7.81568C29.7669 8.63523 31.5197 9.91129 32.9064 11.5392C34.2931 13.1671 35.2742 15.1006 35.7693 17.1809C36.2643 19.2613 36.2592 21.4294 35.7544 23.5075C35.2495 25.5855 34.2593 27.5143 32.865 29.1356L33.4481 29.6981Z"
        fill={color}
      />
      <path
        d="M11.1356 28.2188L16.2812 23.0731L17.7606 24.5525L12.615 29.6981L17.7606 34.8438L16.2812 36.3231L11.1356 31.1775L5.99 36.3231L4.51062 34.8438L9.65625 29.6981L4.51062 24.5525L5.99 23.0731L11.1356 28.2188Z"
        fill={color}
      />
    </svg>
  )
}
